import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import MarcasCreate from "./MarcasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoMarcas() {
  const { user } = useContext(AuthContext);
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [marcas, setMarcas] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMarcas = response.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editMarca(event) {
    event.preventDefault();
    const URL_MARCAS_EDIT = `${process.env.REACT_APP_URL_MARCAS}/${idEdit}`;
    axios
      .patch(
        URL_MARCAS_EDIT,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Marca',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name) {
        setName(name);
        setIdEdit(idEdit);
        toggle();
  }

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  return (
    <>
      <Header />
      <br />
      <div className="container">
        { user.menu_articulos ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-tshirt" style={{ marginRight: 8, color: "#8b5cf6" }} />
                  Marcas
                </h3>
                <p className="page-subtitle">Catálogo de marcas</p>
              </div>
              <div className="page-actions">
                <Button size="sm" color="success" onClick={toggleCreate}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Marca
                </Button>
              </div>
            </div>
            <Table
              size="sm"
              striped
              borderless
              className="table-responsive-xl table-dark-header"
            >
              <thead>
                <tr>
                  <th className="tituloTabla">Nombre</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                      return (
                        <tr>
                          <td>{a.name}</td>
                          <td>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaInfo(a._id, a.name)}
                            >
                              <i class="far fa-edit"></i>{" "}
                            </Button>
                          </td>
                        </tr>
                      );
                  })}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      {/* Modal de alta */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Nueva Marca
        </ModalHeader>
        <ModalBody>
          <MarcasCreate />
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-edit" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Editar Marcas
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-tag" />
              <span className="form-section-title">Datos</span>
            </div>
            <div className="form-section-body">
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editMarca}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoMarcas;
